/**
 * Shared, deduped `/cart.js` read (2026-10-03, real inefficiency found
 * during a site speed-test pass): hygeon-anfrage-cart-guard.js and
 * hygeon-pallet-upgrade.js each independently wrap window.fetch and, a
 * short delay after the SAME real /cart/add call, fetch /cart.js on
 * their own to inspect the cart — neither knows the other exists, so a
 * single "add to cart" click was firing 2+ redundant /cart.js requests
 * (confirmed via the Performance Resource Timing API: 3 separate
 * /cart.js calls within ~150ms of each other for one add).
 *
 * window.HygeonCartFetch() replaces both scripts' own direct
 * `fetch('/cart.js', ...)` calls. A short-lived cache (TTL below) lets
 * the second caller reuse the first caller's already-in-flight/just-
 * resolved response instead of hitting the network again — the two
 * scripts' own delays (60ms / 80ms) after the same add event land well
 * inside this window, so they always share one real request. The TTL
 * is kept short specifically so this never serves truly stale data to
 * an unrelated, later cart check (e.g. the pageshow/bfcache sweep).
 *
 * Must load before hygeon-anfrage-cart-guard.js and
 * hygeon-pallet-upgrade.js (both are defer scripts; this one is too,
 * and sits first in layout/theme.liquid, so script order is preserved).
 */
(function () {
  'use strict';
  var cached = null; // { promise, ts }
  var TTL_MS = 400;

  window.HygeonCartFetch = function (force) {
    var now = Date.now();
    if (!force && cached && now - cached.ts < TTL_MS) {
      return cached.promise;
    }
    var promise = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
    cached = { promise: promise, ts: now };
    return promise;
  };
})();
